export default __webpack_public_path__ + "static/media/classroom.85d37b8a.jpg";